<script>
export default {
  name: "InstitutionSelector",
  props: {
    institutions: {
      type: Array,
      required: true
    }
  },
  emits: ["select"]
};
</script>

<template>
  <div class="institution-selector">
    <h1 class="institution-selector__heading">{{ $t("institutionSelector.heading") }}</h1>
    <p class="institution-selector__description">{{ $t("institutionSelector.description") }}</p>
    <div class="institution-selector__list">
      <button
        v-for="institution in institutions"
        :key="institution.id"
        class="institution-selector__button"
        @click="$emit('select', institution)"
      >
        {{ institution.name }}
      </button>
    </div>
  </div>
</template>
